import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import $ from 'jquery';
import App from './App';

// Expose jQuery as window.$ / window.jQuery for external vendor scripts (e.g. those
// loaded via plain <script> tags in index.html) that expect the classic global jQuery
// API rather than an ES module import. Must run before any such vendor script executes,
// so this assignment happens here at the very top of the app's entry point.
window.$ = $;
window.jQuery = $;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);